export const ObjectEntriesEmpty = <T>(values: T) => {
    return Object.entries(values)
        .filter(([ _, v ]) => v != null)
        .reduce((acc, [ k, v ]) => ({ ...acc, [k]: v }), {});
};

